'use client';

import { PolicyPage } from 'components/organisms/PolicyPage';

const TermsCookiesPage = () => <PolicyPage id="b4075170-8f79-4ca6-a0eb-766b98dace60" />;

export default TermsCookiesPage;
